import { GetUserCustomSettings } from './user-settings';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat); // added fro dynamic date conversition

export const DATE_FORMATS = {
  API_PARAM: 'MM/DD/YYYY'
};

export const formatDate = (date: Date): string => {
  return formatISODate(date.toISOString());
};

export const formatISODate = (isoDate: string = ''): string => {
  if (!isoDate || isoDate === '') {
    return isoDate;
  }
  const _isoFromDate = isoDate.split('T')[0];
  const arr = _isoFromDate.split('-');
  return `${arr[1]}/${arr[2]}/${arr[0]}`;
};

export const generalDateFormate = (isoDate: string = ''): string => {
  if (!isoDate || isoDate === '') {
    return isoDate;
  }
  const date = new Date(isoDate);
  const formattedDate = userFormatedDate(date, true);
  return formattedDate;
};

interface GeneralDateTimeFormatTypes {
  showSeconds?: boolean;
  hideTime?: boolean;
}
export const generalDateTimeFormat = (isoDate: string = '', options?: { showSeconds?: boolean; hideTime?: boolean }): string => {
  if (!isoDate) return isoDate;
  const date = new Date(isoDate);
  // Extract time parts
  // const hour = date.toLocaleString('en-GB', { hour: '2-digit', hour12: false });
  // const minute = date.toLocaleString('en-GB', { minute: '2-digit' });
  // const second = options?.showSeconds ? date.toLocaleString('en-GB', { second: '2-digit' }) : null;
  const [hour, minute] = date
    .toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
    .split(':');

  const time =  `${hour}:${minute}`;
  // Capitalize first letter of each word (optional)
  const formattedDate = userFormatedDate(date);

  // Add time unless hidden
  return options?.hideTime ? formattedDate : `${formattedDate} ${time}`;
};

export const userSelectedFormat = (ignoreUserSettings?: boolean): string => {
  let format = 'DD/MM/YYYY';
  const dateFormat = GetUserCustomSettings().DateTimeFormat;
  if (!ignoreUserSettings) {
    format = typeof dateFormat === 'string' ? dateFormat.replace('HH:mm', '') : format;
  }

  return format;
};

const userFormatedDate = (date: Date | string, ignoreUserSettings?: boolean): string => {
  const dateObj = dayjs(date);

  if (!dateObj.isValid()) return '';

  if (ignoreUserSettings) {
    return dateObj.format('DD/MM/YYYY');
  }

  const formatFromSettings = GetUserCustomSettings().DateTimeFormat;

  // Basic fallback
  const fallbackFormat = 'DD MMM YYYY';

  // Use dynamic format if valid
  const validFormat = typeof formatFromSettings === 'string' ? formatFromSettings.replace('HH:mm', '') : fallbackFormat;

  return dateObj.format(validFormat);
};


export const generateTimeFormat = (isoDate: string = '', options?: GeneralDateTimeFormatTypes): string => {
  if (!isoDate || isoDate === '') {
    return isoDate;
  }
  const date = new Date(isoDate);
  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
  if (options?.showSeconds) {
    timeOptions.second = '2-digit';
  }

  const formattedTime = date.toLocaleTimeString('en-GB', timeOptions);

  return formattedTime.toUpperCase();
};

export const TrainingDateTimeFormat = (isoDate: string = '', options?: GeneralDateTimeFormatTypes): string => {
  if (!isoDate || isoDate === '') {
    return isoDate;
  }
  const date = new Date(isoDate.replace(' ', 'T').replace(/\./g, ':'));
  const dateOptions: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
  if (options?.showSeconds) {
    timeOptions.second = '2-digit';
  }

  const formattedDate = date.toLocaleDateString('en-GB', dateOptions);
  const formattedTime = date.toLocaleTimeString('en-GB', timeOptions);

  return `${formattedDate.replace(/\b\w/g, (char) => char.toUpperCase())}${!options?.hideTime ? ` ${formattedTime}` : ''}`;
};

export const getDateFromTimestamp = (_ts: any) => new Date(_ts * 1000);

export const getCurrentTimeDiff = (_time: any) => Date.now() - _time;

export const isDateExpired = (utcTimeString: string) => {
  const currentTime = new Date();
  const currentUTCTime = new Date(currentTime.getTime() - currentTime.getTimezoneOffset() * 60000);

  const targetUTCDate = new Date(utcTimeString);

  return targetUTCDate < currentUTCTime;
};

export const isTimestampExpired = (utcTimeStamp: number) => Date.now() > utcTimeStamp * 1000;
